
  import {Component, Prop, Vue} from "vue-property-decorator";
  import axios from "axios";
  @Component({
    name:'ExportButton'
  })
  export default class ExportButton extends Vue {


    @Prop({required:true})
    queryModel!:object;

    @Prop({required:true})
    url!:string;
    @Prop({required:true})
    fileTitle!:string;

    @Prop({required:false,default:'xls'})
    fileExtension!:string;

    loading:boolean =false;

    handleExport(){
      this.loading = true;
      axios(this.url,{
          method:'POST',
          baseURL:process.env.VUE_APP_BASE_API,
          data:this.queryModel,
          responseType:'blob',
          headers:{
            'Authorization':`Bearer ${this.$store.getters['user/token']}`,
            '.AspNetCore.Culture':'c=zh-Hans|uic=zh-Hans',
            'Abp-ManagePlatform':true,
            'Abp-OrganizationUnitId':this.$store.getters['user/ouId'],
            'Abp-TenantId':this.$store.getters['app/tenantId']
          },

      }).then(res=>{
        if(!res){
          this.loading = false;
          return
        }
        let url = window.URL.createObjectURL(new Blob([res.data]));
        let link = document.createElement('a');
        link.style.display = 'none';
        link.href = url;
        link.setAttribute('download', `${this.fileTitle}.${this.fileExtension}`);

        document.body.appendChild(link);
        setTimeout(()=>{
          link.click();
          this.loading = false;
        },300);


      });

    }


  }
